<template>
 <div class="container">

<h1><font-awesome-icon icon="home" /> Home  - <a href="#">Event </a>

<!--<div class="float-right">


   <b-button v-b-modal.modal-lg v-b-tooltip.hover title="Help" ><font-awesome-icon icon="info" /></b-button> 

  




</div>-->


</h1>

 

<div class="row">
  <div class="col-md-2 border-right">
    <Tap3/>
  </div>
  <div class="col-md-10">
    <div class="tab-content" id="v-pills-tabContent">
      <div class="tab-pane fade show active" id="v-pills-Current" role="tabpanel" aria-labelledby="v-pills-Current-tab"><ActiveEvent/></div>
      <div class="tab-pane fade" id="v-pills-History" role="tabpanel" aria-labelledby="v-pills-History-tab"><AllEvents /></div>
      <div class="tab-pane fade" id="v-pills-History2" role="tabpanel" aria-labelledby="v-pills-History-tab2"><SearchEvent /></div>
       <div class="tab-pane fade" id="v-pills-History3" role="tabpanel" aria-labelledby="v-pills-History-tab3"><Next /></div>

    </div>
  </div>





</div>




</div>

</template>

<script>
import Tap3 from "../../components/Event/Tap3.vue";
import ActiveEvent from "../../components/Event/ActiveEvent.vue";
 import AllEvents from "../../components/Event/AllEvents.vue";
  import Next from "../../components/Event/Next.vue";
 import SearchEvent from "../../components/Event/SearchEvent.vue";
import studentData from '../../services/Event/event.services'

export default {
   components: {
      Tap3,ActiveEvent,AllEvents,SearchEvent,Next,
//   
  },
  data () {
    return {
      info: '',
  
    }
  },
   computed:{
          currenUser(){
            return  this.$store.state.auth.user
          },
        
        },

  mounted(){
        
      //this.currenUser.StudentID
            studentData.GetStudentAccountDetails(this.currenUser.StudentID).then(Response =>{
              // this.isLoading = false ;
               this.AccountDetails = Response.data
                // eslint-disable-next-line no-console
                  console.log(Response.data)
           }, error => {
              
                  // eslint-disable-next-line no-console
                  console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            })
  }
  



}


</script>

<style scoped>
h1{
    color:#285475;
    font-size:25px;
    border-bottom:1px #646464 dashed;
    padding:10px 0px;
}
h1 a{
    color:#50BD77;
}

.panal{
  background:#eee;
  border-radius:10px;
color:#333;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;


}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}


</style>